import React from "react";
import CustomerList from "./CustomerList";

const CustomerListV2 = () => <CustomerList />;

export default CustomerListV2;
